"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogActionsBarVue2 = exports.DialogActionsBar = void 0; // @ts-ignore

var Vue = require("vue");

var allVue = Vue;
var gh = allVue.h;

var kendo_vue_common_1 = require("@progress/kendo-vue-common");
/**
 * Represents the default `DialogActionsBar` component.
 */


var DialogActionsBarVue2 = {
  name: 'DialogActionsBar',
  props: {
    layout: {
      type: String,
      default: 'stretched'
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  computed: {
    wrapperClasses: function wrapperClasses() {
      var layout = this.$props.layout;
      return {
        'k-dialog-buttongroup': true,
        'k-actions': true,
        'k-hstack': true,
        'k-justify-content-start': layout === 'start',
        'k-justify-content-center': layout === 'center',
        'k-justify-content-end': layout === 'end',
        'k-justify-content-stretch': layout === 'stretched'
      };
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = kendo_vue_common_1.getDefaultSlots(this);
    return h("div", {
      "class": this.wrapperClasses
    }, [defaultSlot]);
  }
};
exports.DialogActionsBarVue2 = DialogActionsBarVue2;
var DialogActionsBar = DialogActionsBarVue2;
exports.DialogActionsBar = DialogActionsBar;